<script setup lang="ts">
  import type { QuotedPlanVm } from '~/models/quoting/QuotedPlan'
  import type { PlanBannerConfig } from '~/composables/PlanBanners'

  const props = defineProps<{
    quote: QuotedPlanVm
    id?: string
    banner?: Partial<PlanBannerConfig & { text: string }> | null | undefined
    stacked?: boolean
  }>()

  const { getId } = Id.use(props.id ?? props.quote.medicareId)
</script>

<template>
  <QuoteCardBenefitHighlightsBase :id="getId()" :quote="quote" :stacked="stacked">
    <template #header>
      <QuoteCardHeaderBenefitHighlights
        :quote="quote"
        :banner="banner"
        :id="getId('header')"
        :stacked="stacked"
      />
    </template>

    <template #default>
      <QuoteCardSectionBenefitHighlightsStats
        :stacked="stacked"
        :quote="quote"
        :id="getId('stats')"
      />
      <QuoteCardSectionBenefitHighlights
        :quote="quote"
        :id="getId('quick-view')"
        :stacked="stacked"
      />
    </template>

    <template #footer>
      <QuoteCardFooterBenefitHighlights :quote="quote" :stacked="stacked" />
    </template>
  </QuoteCardBenefitHighlightsBase>
</template>

<style scoped></style>
